unit CategoryItemType;
{

/* Initial. */

}
interface

uses
  JS;

type
  TCategoryItemType = class
  private
    fCategoryKey: String;
    fName: String;
    fActive: Boolean;
  public
    property CategoryKey: String read fCategoryKey;
    property Name: String read fName;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TCategoryItemType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fCategoryKey := String(JSObject_Type['categoryKey']);
    fName := String(JSObject_Type['name']);
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
